import sqlServer from './lib/sqlServer.js';
import oracel from './lib/oracel.js';
import mySql from './lib/mySql.js';
export default class dataBase {
    constructor(connectString){
        this.dataBase;
        this.type = this._getTypeFromString(connectString);
        this._init();
    }
    /*
        功能：根据类型初始化
    */
    _init(){
        switch(this.type){
            case "sqlServer":
                this.dataBase = sqlServer;
                break;
            case "oracel":
                this.dataBase = oracel;
                break;
            case "mySql":
                this.dataBase = mySql;
                break;
            default :
                this.dataBase = sqlServer;
                break;
        }
    }
    /*
        功能：根据连接字串获取数据库类型
        connectString ： 连接字串
    */
    _getTypeFromString(connectString){
        var type = "sqlServer"
        var dataBaseType = connectString.match(/Provider=([^;]*);/)[1];
        if(dataBaseType == "SQLOLEDB.1" || dataBaseType == "SQLOLEDB.1"){
            type = "sqlServer";
        }else if(dataBaseType == "OraOLEDB.Oracle" 
                    || dataBaseType == "OraOLEDB.Oracle.1" 
                    || dataBaseType == "MSDAORA.1"
                    || dataBaseType == "{Oracle  in  instantclient_12}"){
            type = "oracel";
        }else if(dataBaseType == "{MySQL}" || dataBaseType == "{MySQL ODBC 3.51Driver}" 
                    || dataBaseType == "{MySQL ODBC 3.51Driver}"
                    || dataBaseType == "MySQLProv"
                    || dataBaseType == "myServerAddress"
                    || dataBaseType == "myServerAddress1"){
                        type = "mySql";
        }
        return type; 
    }
    /*
        功能：根据连接字串获取默认数据库
        connectString ： 连接字串
    */
    getDefaultDataBase(connectString){
        return this.dataBase.getDefaultDataBase(connectString);
    }
    /*
        功能：格式化sql语句
        sql ： 连接字串
    */
    FilterSQL(sql){
        return this.dataBase.FilterSQL(sql);
    }

    initOptions(options){
        this.dataBase.initOptions(options);
    }
}


// WEBPACK FOOTER //
// ./src/js/backstage/fvADOModule/dataBase.js